import { GET_LOGS } from '../../constants/actions/policy';

export function getLogs(payload) {
    return {
        type: GET_LOGS,
        payload,
    };
}
